import React from "react";
export function Footer() {
  return <footer className="w-full bg-navy-deep px-4 pb-28 pt-10 text-center" data-id="element-156" data-mp="19ivlq3plplne">
      <p className="font-serif text-xl font-black text-white" data-id="element-157" data-mp="206j57nelojgi">Implant Case Decision™</p>
      <p className="mt-1 text-sm text-white/60" data-id="element-158" data-mp="2f53fjo5x71jx">A clinical decision framework by Dr. Michael Carter</p>
      <p className="mx-auto mt-5 max-w-xl text-xs leading-relaxed text-white/50" data-id="element-159" data-mp="2a5gwuz7bot3q">
        This material does not replace formal clinical education, supervised training, professional judgment, or applicable local standards of care.
      </p>
      <p className="mt-5 text-xs text-white/50" data-id="element-160" data-mp="1heynjgg09vhv">© 2026 · Dr. Michael Carter – Implant Case Decision™. All rights reserved.</p>
    </footer>;
}